import React from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import Loader from "components/Loader";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// local
import ItemContainer from "./ItemContainer";
import Filters from "./Filters";

// redux
import { useSelector, useDispatch } from "react-redux";
import * as actions from "redux/actions/item";
import * as actionTypes from "redux/constants";

const Item = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const item = useSelector((state) => state.item);
  const auth = useSelector((state) => state.auth);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [item.pagination.page]);

  React.useEffect(() => {
    dispatch(actions.getItems(item.pagination.page, item.pagination.pageSize));

    return () => {
      dispatch(actions.resetItemsPagination());
    };
  }, [dispatch]);

  const handlePagination = (page) => {
    dispatch(actions.getItems(page, item.pagination.pageSize));
  };

  const handleDelete = (id) => {
    const payload = { id };
    dispatch(actions.deleteItem(payload));
  };

  const handleEdit = (data) => {
    navigate(`/upload/item/add-item`, { state: { editData: data } });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container>
        {item.loading ? (
          <Loader />
        ) : (
          <>
            {actionTypes.ADVANCED_SECTION.includes(auth.user?.role) && (
              <Grid item xs={12} md={12} xl={12}>
                <MDBox py={3} pl={1}>
                  <Filters />
                </MDBox>
              </Grid>
            )}
            <Grid item xs={12} md={12} xl={12}>
              <MDBox py={3} pr={1}>
                <ItemContainer
                  items={item.items}
                  pagination={item.pagination}
                  handlePagination={handlePagination}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                />
              </MDBox>
            </Grid>
          </>
        )}
      </Grid>
    </DashboardLayout>
  );
};

export default Item;
